import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/Energy_Star_Logo_2x.png")